import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const HMACContainer = styled.div`
  display: flex;
  gap: 8px;
  font-family: var(--font-family-mono);
  align-items: center;
`
